<template>
  <Layout>
    <div v-if="!show_ie">
      <!-- <Appdowload></Appdowload> -->
      <div class="bordertop2">
        <div>
          <div class="header">
          <HeaderNav name="1"></HeaderNav>
        </div>
          <div class="swiper-container margin_top70">
            <div class="swiper-wrapper banner-swiper">
              <div v-for="banner in banners" class="swiper-slide">
                <!-- <a v-if="banner.attr_id==0" :href="banner.content">
                  <img
                    src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/banner.png"
                  />
                </a>
                <router-link
                  v-else-if="banner.attr_id==1"
                  :to="{path:'/mall/detail',query:{id:banner.content}}"
                >
                  <img
                    src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/banner.png"
                  />
                </router-link>
                <router-link
                  v-else-if="banner.attr_id==2"
                  :to="{path:'/train/detail',query:{id:banner.content}}"
                >
                  <img
                    src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/banner.png"
                  />
                </router-link>
                <router-link
                  v-else-if="banner.attr_id==3"
                  :to="{path:'/online/detail',query:{id:banner.content}}"
                >
                  <img
                    src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/banner.png"
                  />
                </router-link>
                <img
                  v-else
                  src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/banner.png"
                /> -->
                 <!-- <img
                    src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/banner.png"
                  /> -->
                  <img src="../../assets/index/banner1.jpg" />
              </div>
            </div>
          </div>
        </div>
        <!-- 关于我们 -->
        <div class="latest-out">
          <div class="title">
            <h1>关于我们</h1>
            <p>ABOUT US</p>
          </div>
          <div class="out">
            <div class="left">
              <div class="outtitle">ABOUT US</div>
              <div class="name">关于邱显峰整体瑜伽</div>
              <div class="details">
                也许你在瑜伽界已有十年或甚至更久的经历，到处寻觅各式各样的课程，甚至到过印度和其他国家好几回，也花了不少金钱和宝贵时间，然而你对瑜伽是否已有了全貌的了解？是否瑜伽体位法就是瑜伽的全部，还是说瑜伽还有其文化和更深的内涵？
                为了帮助社会大众以及瑜伽老师和瑜伽爱好者能认识并学到身心灵完整锻炼的精髓，邱老师特别将此整套系统取名为邱显峰整体瑜伽，并藉此系统来推广。
              </div>
            </div>
            <div class="picture">
              <img
                src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC.png"
              />
            </div>
          </div>
        </div>

        <!-- 名师介绍 -->
        <div class="top-teacher">
          <div class="title">
            <h1>名师介绍</h1>
            <p>TEACHER INTRODUCES</p>
          </div>
          <div
            class="out"
          >邱显峰导师从1989年年初开始从事瑜伽教学，迄今已近30年，时间不算很长，但也不短。而且在从事瑜伽教学前17年就已开始学习身心灵的锻炼，从不同的派别参研禅坐、灵修、气功、养生与医学等，并从1973年起开始教授身心灵的整体锻炼。至今已出版《胜王瑜伽经详解》、《哈达瑜伽经详解》、《王者之王瑜伽经》、《博伽梵歌灵性释义》、《老子道德经与瑜伽心法》、《脉轮与拙火瑜伽》和《如何针对不同体质和疾病患者调配五谷饭》等七部书。从事教学总时数已近24000小时，累积了丰富的教学经验，且经常受邀到大陆授课。所教授的内容可说是瑜伽最上乘的秘法，可适合各种根器的人，不论是初学者或已历经深造过的人，邱老师都会循循善诱引导学员由浅入深，一探生命最深的奥秘。</div>
        </div>
        <!-- <slider :pages="pages" :sliderinit="sliderinit">
        </slider>-->
        <!-- 学习过程-->
        <div class="learning-process" style="height:390px;overflow:hidden;">
          <div v-show="one" v-for="(l,index) in listData" :key="index">
            <div class="outs" v-if="num==index">
              <div class="picture">
                <img :src="l.img" />
              </div>
              <div class="details">
                <h2>{{l.name}}</h2>
                <div class="introduce" style="white-space: pre-line;">
                  <div style="padding-right:50px">{{l.dec}}</div>
                </div>
              </div>
            </div>
             <div class="number">
                <div v-for="(n,index) in numbers" :key="index">
                  <a @mouseover="changeMask(index)" @mouseleave="changeMaskLeave(index)">
                    <div
                      id="button"
                      style="width:100px;height:60px;text-align:center"
                      @click="handleCutOne(n,index)"
                      :style="num==index?'color:#FF0056':''"
                    >{{n.name}}</div>
                  </a>
                </div>
              </div>
          </div>
        </div>
        <!--最新培训 -->
        <div class="new-train-training" v-if="newinfo.length!=0">
          <div class="title">
            <h1>最新培训</h1>
            <p>THE LATEST TRAINING</p>
          </div>
          <div class="out">
            <div class="left">
              <div class="train-name">{{newinfo.train_name}}</div>
              <div class="start-time">活动时间：{{newinfo.train_start_time}} - {{newinfo.train_end_time}}</div>
              <div class="end-time">截止报名日期：{{newinfo.reg_start_time}} - {{newinfo.reg_end_time}}</div>
              <div class="train-teacher-name">培训老师：{{newinfo.teacher_names}}</div>
              <div class="consult" @click="zixun">
                <a style="color:#FF4560">咨询</a>
              </div>
            </div>
            <div class="right">
              <img style="width:425px;height:425px" :src="newinfo_image_url" />
            </div>
          </div>
        </div>
        <div class="top-teacher">
          <div class="title" :style="newinfo.length==0?'padding-top:30px':''">
            <h1>课程介绍</h1>
            <p>COURSE DESCRIPTION</p>
          </div>
          <div
            class="out"
          >为了帮助大家有系统的学习，特别规划了整体瑜伽教师705小时证照班学程，此学程共分初级202小时，中级203小时，高级300小时。透过此研习能让参与者经由理论和实际锻炼中获得前所未有圆满体验，并大大的帮助参与者了悟到天人合一的瑜伽。课程的主要内容有知识瑜伽（jñāna yoga）、行动瑜伽（karma yoga）、禅那瑜伽（dhyāna yoga）和虔诚瑜伽（bhakti yoga），以及瑜伽饮食观、断食法，印度阿育医学（āyur veda）、瑜伽理疗，预防瑜伽运动伤害，五大元素与心灵转化，瑜伽经典，瑜伽眠，瑜伽常用梵文解说，…等。</div>
        </div>
        <div class="courses">
          <div class="courses_item" v-for="item in courses" :key="item.id">
            <p class="courses_item_tit">{{item.title}}</p>
            <div class="courses_item_des">
              <p v-for="(item2,index2) in item.des" :key="index2">{{item2}}</p>
            </div>
            <a :href="'/pc/static'+item.src" class="courses_item_link" target="_black">查看详情&nbsp;></a>
          </div>
        </div>
        <div class="top-teacher">
          <div class="title">
            <h1>著作介绍</h1>
            <p>ABOUT AUTHOR</p>
          </div>
        </div>
        <div class="famous">
          <a href="/pc/static/work.pdf" target="_black">
            <img src="../../assets/img_famous.png" class="famous_img" alt="著作介绍" />
          </a>
        </div>
        <div class="top-teacher">
          <div class="title">
            <h1>往期剪影</h1>
            <p>PAST SILHOUETTE</p>
          </div>
        </div>
        <div class="past">
          <div v-for="(item,index) in overlists" :key="item.id" class="past_item" v-if="index%2==0">
            <div class="past_item_imgdiv">
              <img :src="item.img" class="past_item_img" alt />
            </div>
            <div class="past_item_des" :style="{'padding-left':'10%'}">
              <a
                v-for="(item2,index2) in item.des"
                :key="index2"
                :href="item2.url"
                target="_black"
                class="past_item_url"
              >
                <span>{{item2.name}}</span>
                <span>></span>
              </a>
            </div>
          </div>
          <div class="past_item" v-else>
            <div
              class="past_item_des"
              :style="{'background-color':'#f8f8f8','padding-right':'10%'}"
            >
              <a
                v-for="(item2,index2) in item.des"
                :key="index2"
                :href="item2.url"
                target="_black"
                class="past_item_url"
              >
                <span>{{item2.name}}</span>
                <span>></span>
              </a>
            </div>
            <div class="past_item_imgdiv">
              <img :src="item.img" class="past_item_img" alt />
            </div>
          </div>
        </div>
        <!--加入我们 start-->
        <div class="qr-training">
          <div class="left">
            <div class="company">公司名称</div>
            <div class="name">沈阳若愚健康咨询有限公司</div>
            <!-- <div class="relation">联系电话：</div>
            <div class="phone">8613998111600</div> -->
            <div class="site">公司地址：</div>
            <div class>辽宁省沈阳市皇姑区昆山中路53号(307)</div>
          </div>
          <div class="center">
            <div class="name">下载邱显峰整体瑜伽APP</div>
            <div class="down-code">扫码 或 <a href="https://jkxuetang-master.oss-cn-shenzhen.aliyuncs.com/tmp/app-release.apk" download="瑜伽安卓" style="color:#ff4560;text-decoration: underline;">点击这里下载</a > APP 注册即可在APP内报名</div>
            <div class="qrcode">
              <div>
                <!-- <img
                  src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/%E8%92%B2%E5%85%AC%E8%8B%B1%E5%AE%89%E5%8D%93.png"
                />-->
                <img src="https://jkxuetang-master.oss-cn-shenzhen.aliyuncs.com/tmp/yoga_android.png" />
                <div class="android">Android端</div>
              </div>
              <div style="padding-left:15px">
                <!-- <img
                  src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/%E8%92%B2%E5%85%AC%E8%8B%B1%E5%AE%89%E5%8D%93.png"
                />-->
                <!-- <img src="../../assets/ios-qrcode.png" />
                <div class="android">ios端</div> -->
              </div>
            </div>
          </div>
          <div class="right">
            <div class="name">关注邱显峰整体瑜伽公众号</div>
            <div class="down-code">扫码关注公众号随时了解最新特惠活动</div>
            <div class="qrcode">
              <!-- <div>
                <img
                  src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/%E5%B0%8F%E7%A8%8B%E5%BA%8F%E7%A0%81.jpg"
                />
                <div class="android">小程序</div>
              </div> -->
              <div style="padding-left:15px">
                <!-- <img
                  src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/%E8%92%B2%E5%85%AC%E8%8B%B1%E5%AE%89%E5%8D%93.png"
                /> -->
                <img src="../../assets/index/gongzhonghao.jpg" />
                <div class="android">公众号</div>
              </div>
            </div>
          </div>
        </div>
        <!--加入我们 end-->
      </div>
      <FooterDes class="ivu-layout-footer"></FooterDes>
    </div>
    <HintIE v-if="show_ie"></HintIE>
  </Layout>
</template>

<script>
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";
import { getData, set_cache_item } from "../../../static/js/util.js";
import config from "../../../static/js/myconfig";
import headernav from "../../components/HeaderNav";
import footer from "../../components/FooterDes";
import Appdowload from "../../components/Appdowload";
import HintIE from "../../components/HintIE";
export default {
  components: {
    Appdowload: Appdowload,
    HeaderNav: headernav,
    FooterDes: footer,
    HintIE: HintIE
  },
  data() {
    return {
      sliderinit: {
        currentPage: 0, //当前页码
        thresholdDistance: 500, //滑动判定距离
        thresholdTime: 100, //滑动判定时间
        autoplay: 1000, //自动滚动[ms]
        loop: true, //循环滚动
        direction: "vertical", //方向设置，垂直滚动
        infinite: 1, //无限滚动前后遍历数
        slidesToScroll: 1 //每次滑动项数
      },
      banners: [],
      aboutus: {},
      newinfo: {},
      newinfo_image_url: "",
      teachers: [],
      pastsilhouette: {},
      show_ie: false,
      imgone: "",
      imgList: [],
      imgtwo: "",
      imgtwoList: [],
      imgthree: "",
      imgthreeList: [],
      imgfour: "",
      imgfourList: [],
      one: true,
      two: false,
      three: false,
      four: false,
      five: false,
      size: false,
      timer: null,
      num: 0,
      numbers: [
        {
          name: "01",
          id: "1"
        },
        {
          name: "02",
          id: "2"
        },
        {
          name: "03",
          id: "3"
        },
        {
          name: "04",
          id: "4"
        }
      ],
      urlone:
        "https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/%E5%BE%80%E6%9C%9F%E5%89%AA%E5%BD%B11.png",
      urltwo:
        "https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/%E5%BE%80%E6%9C%9F%E5%89%AA%E5%BD%B12.png",
      urlthree:
        "https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/%E5%BE%80%E6%9C%9F%E5%89%AA%E5%BD%B13.png",
      urlfour:
        "https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/%E5%BE%80%E6%9C%9F%E5%89%AA%E5%BD%B14.png",
      urlfive:
        "https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/%E5%BE%80%E6%9C%9F%E5%89%AA%E5%BD%B15.png",
      urlsix:
        "https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/%E5%BE%80%E6%9C%9F%E5%89%AA%E5%BD%B16.png",
      // imgs: [
      //   {
      //     url:
      //     title: "图片1"
      //   },
      //   {
      //     url:
      //       "https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/%E5%BE%80%E6%9C%9F%E5%89%AA%E5%BD%B11.png",
      //     title: "图片2"
      //   }
      // ],
      listData: [
        {
          name: "目的及理念",
          img:
            "https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/%E5%90%8D%E5%B8%88-1%E5%AD%A6%E4%B9%A0%E8%BF%87%E7%A8%8B.png",
          dec:
            "• 目的：天人合一\n• 理念：了悟真我，服务社会\n补充解说：透过研修，帮助大家身心灵健康，增进整体人类社会的福祉，并促进人与万物及天地之间的和谐相处，以朝着天人合一的目标前进。"
        },
        {
          name: "传授内容",
          img:
            "https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/%E5%90%8D%E5%B8%88-2%E6%95%99%E6%8E%88%E4%B8%8E%E7%BB%8F%E5%8E%86.png",
          dec:
            "• 中国传统文化，正确和有益的儒家和道家心法 \n" +
            "• 佛家心法 \n" +
            "• 整体瑜伽的心法和功法 \n" +
            "• 自然养生与理疗的功法和心法，其中也包含饮食法和断食法 \n"
        },
        {
          name: "特色1",
          img:
            "https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/%E5%90%8D%E5%B8%88-3%E7%90%86%E8%AE%BA%E7%89%B9%E8%89%B2.png",
          dec:
            "• 将中国传统文化，以及儒家、道家、佛家、太极和瑜伽融合在一起\n" +
            "• 瑜伽方面是结合了哈达瑜伽、胜王瑜伽、王者之王瑜伽和博伽梵歌的教导，并以达到胜王瑜伽经所述的：「 1.身定气定与心悦 2.最高三摩钵底 3.超越二元性」为主，绝对不流于外在形式的锻炼。且在高级的锻炼里，瑜伽是一种个人的生活方式和与万物及至上的自然连结\n" +
            "• 在瑜伽主轴锻炼里：着重三脉七轮与拙火的锻炼；着重内外在五种生命能的锻炼；着重身心灵与八肢瑜伽和道德的整体修持\n"
        },
        {
          name: "特色2",
          img:
            "https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/index/%E5%90%8D%E5%B8%88-4%E4%BB%BB%E8%81%8C%E7%BB%8F%E5%8E%86.png",
          dec:
            "• 虽讲授某些宗教的心法、功法和经典，但本整体瑜伽并不属于任何宗派或宗教，也不是宗教的属性\n" +
            "• 着重自然养生\n" +
            "• 不涉入宗教与政治\n" +
            "• 不以营利为目的\n"
        }
      ],
      courses: [
        {
          id: 1,
          title: "初级课程有四阶，含考照202小时",
          src: "/course1.pdf",
          des: [
            "第一阶：脉轮与胜王瑜伽初级",
            "第二阶：瑜伽呼吸法与身印法初级",
            "第三阶：五大元素与心灵转化瑜伽初级",
            "第四阶：如何预防瑜伽运动伤害",
          ]
        },
        {
          id: 2,
          title: "中级课程有四阶，含考照203小时",
          src: "/course2.pdf",
          des: [
            "第一阶：脉轮与胜王瑜伽中级",
            "第二阶：瑜伽呼吸法与身印法中级",
            "第三阶：五大元素与心灵转化瑜伽中级",
            "第四阶：瑜伽经典与故事集详解",
          ]
        },
        {
          id: 3,
          title: "高级课程有五阶，含考照300小时",
          src: "/course3.pdf",
          des: [
            "第一阶：脉轮与胜王瑜伽高级",
            "第二阶：瑜伽呼吸法与身印法高级",
            "第三阶：五大元素与心灵转化瑜伽高级",
            "第四阶：瑜伽理疗与瑜伽眠",
            "第五阶：瑜伽常用梵文研习"
          ]
        }
      ],
      overlists: [
        {
          id: 1,
          img: require("../../assets/img_over1.png"),
          des: [
            {
              name: "邱显峰兰州脉轮与胜王瑜伽初级教师认证班精采回忆(一)",
              url: "http://blog.sina.com.cn/s/blog_62c0a4490102ym7b.html"
            },
             {
              name: "邱显峰兰州脉轮与胜王瑜伽初级教师认证班精采回忆(二)",
              url: "http://blog.sina.com.cn/s/blog_62c0a4490102ymdo.html"
            },
            {
              name: "邱显峰兰州脉轮与胜王瑜伽初级教师认证班精采回忆(三)",
              url: "http://blog.sina.com.cn/s/blog_62c0a4490102ymk0.html"
            }
          ]
        },
        {
          id: 2,
          img: require("../../assets/img_over2.png"),
          des: [
            {
              name:
                "邱显峰西安瑜伽呼吸法与身印法初级教师认证班二精采回忆(一)",
              url: "http://blog.sina.com.cn/s/blog_62c0a4490102ynwx.html"
            },
            {
              name: "邱显峰西安瑜伽呼吸法与身印法初级教师认证班二精采回忆(二)",
              url: "http://blog.sina.com.cn/s/blog_62c0a4490102yny2.html"
            },
            {
              name: "邱显峰西安瑜伽呼吸法与身印法初级教师认证班二精采回忆(三)",
              url: "http://blog.sina.com.cn/s/blog_62c0a4490102yo18.html"
            },
            {
              name: "邱显峰西安瑜伽呼吸法与身印法初级教师认证班二精采回忆(四)",
              url: "http://blog.sina.com.cn/s/blog_62c0a4490102yqhu.html"
            }
          ]
        },
        {
          id: 3,
          img: require("../../assets/img_over3.png"),
          des: [
            {
              name: "邱显峰太原脉轮与胜王瑜伽中级教师认证班精采回忆(一)",
              url: "http://blog.sina.com.cn/s/blog_62c0a4490102yflm.html"
            },
            {
              name: "邱显峰太原脉轮与胜王瑜伽中级教师认证班精采回忆(二)",
              url: "http://blog.sina.com.cn/s/blog_62c0a4490102yg0x.html"
            },
            {
              name: "邱显峰太原脉轮与胜王瑜伽中级教师认证班精采回忆(三)",
              url: "http://blog.sina.com.cn/s/blog_62c0a4490102yg1n.html"
            },
            {
              name: "邱显峰太原脉轮与胜王瑜伽中级教师认证班精采回忆(四)",
              url: "http://blog.sina.com.cn/s/blog_62c0a4490102yg5h.html"
            }
          ]
        }
      ],
      interval:""
    };
  },

  methods: {
    // getScroll(){
    //   let scrollTop;
    //  scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    //  console.info("scrollTop",scrollTop)
    // },
    handleCutOne(item, index) {
      this.num = index;
    },
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window)
        this.show_ie = true; //不支持IE
    },
    zixun() {
      this.$alert("更多内容请扫描下载APP体验", "", {
        confirmButtonText: "确定",
        showClose: false
      });
    },
    getBanners: function() {
      var that = this;
      getData(config.apimethod.getBanners + "?type=1", function(res) {
        console.info("res", res);
        var data = res.data;
        that.banners = data;
        if (data != undefined && data.length > 0) {
          setTimeout(function() {
            new Swiper(".swiper-container", {
              loop: false,
              autoplay: true,
              speed: 400
              // 如果需要分页器
              // pagination: '.swiper-pagination',
              // // 如果需要前进后退按钮
              // nextButton: '.swiper-button-next',
              // prevButton: '.swiper-button-prev',
              // // 如果需要滚动条
              // scrollbar: '.swiper-scrollbar',
            });
          }, 1000);
        }
      });
    },
    getAboutUs: function() {
      var that = this;
      getData(config.apimethod.getAboutUs, function(res) {
        var data = res.data;
        that.aboutus = data;
      });
    },
    getNewInfo: function() {
      
      var that = this;
      getData(config.apimethod.getNewInfo, function(res) {
        console.info("123123123")
        if (res.data.length == 0) {
          that.newinfo = [];
          return;
        }
        var data = res.data;
        console.log("data--->", data);
        data.teacher_names = "";
        for (var i = 0; i < data.teacher.length; i++) {
          data.teacher_names += data.teacher[i].teacher_name + "  ";
        }

        that.newinfo = data;
        console.info("that",that.newinfo)
        that.newinfo_image_url = data.image_url[0];
      });
    },
    getPastsilhouette: function() {
      var that = this;
      getData(config.apimethod.getPastsilhouette, function(res) {
        var data = res.data;
        console.log(data);
        that.pastsilhouette = data.imgs;

        that.imgone = data.imgs.imgsone;
        that.imgList.push(data.imgs.imgsone);

        that.imgtwo = data.imgs.imgstwo;
        that.imgtwoList.push(data.imgs.imgstwo);

        that.imgthree = data.imgs.imgstress;
        that.imgthreeList.push(data.imgs.imgstress);

        that.imgfour = data.imgs.imsfive;
        that.imgfourList.push(data.imgs.imsfive);
      });
    },
    getTeacher: function() {
      var that = this;
      getData(config.apimethod.getTeacher, function(res) {
        var data = res.data;
        that.teachers = data.data;
        setTimeout(function() {
          new Swiper(".teacher-container", {
            loop: false,
            autoplay: true,
            speed: 400,
            // 如果需要分页器
            pagination: ".teacher-swiper-pagination"
            // // 如果需要前进后退按钮
            // nextButton: '.swiper-button-next',
            // prevButton: '.swiper-button-prev',
            // // 如果需要滚动条
            // scrollbar: '.swiper-scrollbar',
          });
        }, 1000);
      });
    },
    //鼠标经过,暂停轮播
    changeMask(index) {
      this.num = index;
      clearInterval(this.interval);
    },
    //鼠标离开，重新自动轮播
    changeMaskLeave(index){
      this.num = index;
      var interval = setInterval(() => {
        this.num++;
        if (this.num >= 4) {
          this.num = 0;
        }
      }, 2400);
     this.interval = interval;
    },
  },
  mounted() {
    this.getBanners();
    this.getAboutUs();
    this.getNewInfo();
    this.getTeacher();
    this.getPastsilhouette();
    this.isIE();
    //实行自动切换图片
    var interval = setInterval(() => {
      this.num++;
      if (this.num == 4) {
        this.num = 0;
      }
    }, 2400);
    this.interval = interval;
  }
};
</script>

<style scope>
.margin_top70 {
  margin-top: 70px!important;
}
.indexnews .newslist {
  border: none;
  padding: 0 16px;
}
.indexnews .ivu-card-body {
  padding: 0;
}
.abstit {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px 0;
}
.el-image-viewer__canvas {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.el-carousel__container {
  height: 400px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.outs {
  /* animation: myfirst 2s; */
  animation: move 2s ease-out infinite;
}
@keyframes move {
  /* from {
    background: white;
  }
  to {
    background: #f7f7f7;
  } */
}

.up {
  animation-name: move; /*动画的名称*/
  transform-origin: center bottom; /*设置动画旋转元素的基点为*/
  cursor: pointer;
}
.viewer-prev,
.viewer-play,
.viewer-next {
  display: none;
}
/* @media screen and (max-width: 1250px) {
  .layout-footer-center {
    width: 1800px;
  }
} */
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue